import { t } from "../i18n";
import { useEffect, useState, type FormEvent } from "react";
import { useSearchParams } from "react-router-dom";
import { authUrl } from "../api";

export function InvitationAcceptancePage() {
  const [params] = useSearchParams();
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const token = params.get("token") ?? "";
  useEffect(() => {
    if (!token) setError("This invitation link is missing its token.");
  }, [token]);
  const accept = async (event: FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      const response = await fetch(authUrl("organization-invitations/accept"), {
        method: "POST",
        credentials: "include",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ token, name, password }),
      });
      if (!response.ok) {
        const body = (await response.json().catch(() => ({}))) as {
          error?: string;
        };
        throw new Error(body.error ?? `Request failed (${response.status})`);
      }
      setMessage("Invitation accepted. Redirecting to your organization…");
      window.setTimeout(
        () => window.location.assign(`/settings/organization`),
        600,
      );
    } catch (cause) {
      setError(
        cause instanceof Error
          ? cause.message
          : "Invitation could not be accepted",
      );
    } finally {
      setSubmitting(false);
    }
  };
  const reject = async () => {
    setSubmitting(true);
    setError("");
    try {
      const response = await fetch(authUrl("organization-invitations/reject"), {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ token }),
      });
      if (!response.ok) {
        const body = (await response.json().catch(() => ({}))) as {
          error?: string;
        };
        throw new Error(body.error ?? `Request failed (${response.status})`);
      }
      setMessage("Invitation declined.");
    } catch (cause) {
      setError(
        cause instanceof Error
          ? cause.message
          : "Invitation could not be declined",
      );
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <section className="mx-auto flex w-full max-w-lg flex-1 items-center justify-center p-6">
      <div className="panel w-full p-6 text-center">
        <h1 className="text-xl font-bold">{t("Organization invitation")}</h1>
        <p
          className={`mt-3 text-sm ${error ? "text-red-600" : "text-stone-600 dark:text-stone-300"}`}
        >
          {error || message}
        </p>
        {!error && !message && token && (
          <form className="mt-5 space-y-3 text-left" onSubmit={accept}>
            <input
              className="field w-full"
              placeholder={t("Your name")}
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
            <input
              className="field w-full"
              type="password"
              minLength={12}
              placeholder={t("Create a password (12+ characters)")}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
            <button
              className="button-primary w-full"
              disabled={submitting}
              type="submit"
            >
              {submitting ? "Accepting…" : "Accept invitation"}
            </button>
            <button
              className="button-secondary w-full"
              disabled={submitting}
              type="button"
              onClick={() => void reject()}
            >
              {t("Decline invitation")}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
